import React, { CSSProperties } from 'react';
import MButtonView from './MButton.view';
import { ComponentSizes, ThemeColors } from 'models/general';
import { MButtonThemes } from './MButton.model';

type Props = {
  theme?: MButtonThemes;
  className?: string;
  color?: ThemeColors;
  disabled?: boolean;
  type?: 'submit' | 'reset' | 'button';
  block?: boolean;
  to?: string;
  style?: CSSProperties;
  size?: ComponentSizes;
  tabIndex?: number;
  isLoading?: boolean;
  percentage?: number;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  onBlur?: (event?:React.FocusEvent<HTMLButtonElement> ) => void;
  onFocus?: () => void;
};

const MButton: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <MButtonView
      theme={props.theme}
      color={props.color}
      disabled={props.disabled}
      className={props.className}
      isLoading={props.isLoading}
      percentage={props.percentage}
      type={props.type}
      block={props.block}
      style={props.style}
      to={props.to}
      size={props.size}
      tabIndex={props.tabIndex}
      onClick={props.onClick}
      onMouseEnter={props.onMouseEnter}
      onMouseLeave={props.onMouseLeave}
      onBlur={props.onBlur}
      onFocus={props.onFocus}
    >
      {props.children}
    </MButtonView>
  );
};

MButton.displayName = 'MButton';
MButton.defaultProps = {
  theme: MButtonThemes.Filled,
  color: ThemeColors.Primary,
  size: ComponentSizes.Medium,
};

export default MButton;
